import {takeEvery} from 'redux-saga/effects'
import {
  GET_STUDENT_EXAMS,
  GET_STUDENT_EXAM_PERFORMANCE,
  GET_STUDENT_REPORT_CARDS,
  GET_STUDENT_REPORT_CARD_PDF,
} from 'setup/redux/Actions/StudentExam/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

/** Parent/student exam surfaces (exam.md §10). */
function* dataSaga() {
  yield takeEvery(GET_STUDENT_EXAMS, fetchData)
  yield takeEvery(GET_STUDENT_EXAM_PERFORMANCE, fetchData)
  yield takeEvery(GET_STUDENT_REPORT_CARDS, fetchData)
  yield takeEvery(GET_STUDENT_REPORT_CARD_PDF, fetchData)
}

export default dataSaga
